import { Autocomplete, Grid, TextField } from '@mui/material';

import { gridSize } from '@/shared/constants';

export type CustomAutocompleteArrStringNoFormProps = {
  loadingText?: string;
  label: string;
  disabled?: boolean;
  options: string[];
  optionLabelForEdit?: string;
  onChangeValue?: (value: any) => void;
  required?: boolean;
  defaultValue?: string | number;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  disableClearable?: boolean;
  endAdornmentInput?: React.ReactNode;
  sizeAutocomplete?: 'small' | 'medium'
};

function CustomAutocompleteArrStringNoForm({
  options,
  defaultValue,
  required = true,
  label,
  onChangeValue,
  size = gridSize,
  disabled = false,
  disableClearable = false,
  endAdornmentInput,
  sizeAutocomplete = 'medium'
}: Readonly<CustomAutocompleteArrStringNoFormProps>) {
  return (
    <Grid item {...size}>
      <Autocomplete
        size={sizeAutocomplete}
        fullWidth
        freeSolo
        defaultValue={defaultValue?.toString()}
        options={options}
        getOptionLabel={(option: string) => option}
        disabled={disabled}
        disableClearable={disableClearable}
        renderInput={params => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              ...(endAdornmentInput && {
                endAdornment: endAdornmentInput,
              }),
            }}
            disabled={disabled}
            label={label}
            variant="outlined"
            required={required}
          />
        )}
        onChange={(_event: any, data: any) => {
          onChangeValue && onChangeValue(data);
        }}
      />
    </Grid>
  );
}

export default CustomAutocompleteArrStringNoForm;
